/**
 * Centralized copy for all contextual tooltips (`<InfoTip>`).
 *
 * Single source of truth so we can:
 *   • Refine tone-of-voice in one place.
 *   • Translate later without hunting through the codebase.
 *   • Add a "Scopri di più" link / mini-guide page that reads from this map.
 *
 * Tone: premium, semplice, professionale. Una frase di cosa serve + un
 * micro-esempio quando aiuta. Italiano formale ma diretto.
 */

export const TIPS = {
  // ─── ClientDetail · tabs ────────────────────────────────────────────────
  tab_wedding: {
    title: "Scheda Wedding",
    text: "I dati base del matrimonio: sposi, data, location, orari. È il cuore della scheda — tutto il resto del workflow si genera da qui.",
    tip: "Compila prima questa sezione: preventivo e contratto useranno automaticamente questi dati.",
  },
  tab_makeup: {
    title: "Modulo Trucco",
    text: "Gestisci la prova trucco: data, luogo, foto del look, allegati. Puoi condividere un link pubblico con la sposa per riguardare le foto della prova.",
    tip: "Le foto possono essere usate anche dal cliente come reference il giorno del matrimonio.",
  },
  tab_hair: {
    title: "Modulo Capelli",
    text: "Stessa logica del trucco, dedicata all'acconciatura. Foto, allegati e link pubblico per condividere la prova con la sposa.",
  },
  tab_partner: {
    title: "Partner / Fornitori",
    text: "Annota wedding planner, fotografo, location, fioraio e altri fornitori del matrimonio. Sezione interna, non visibile al cliente.",
    tip: "Utile per coordinarsi via WhatsApp o email senza cercare i contatti ogni volta.",
  },
  tab_quote: {
    title: "Preventivo",
    text: "Aggiungi servizi, prezzi e sconti. Il totale si calcola in tempo reale con IVA o regime forfettario. Un click per inviarlo via email o scaricarlo in PDF.",
    tip: "Marca un servizio come Opzionale per farlo confermare al cliente direttamente dalla pagina pubblica.",
  },
  tab_contract: {
    title: "Contratto",
    text: "Genera un contratto pre-compilato con i dati della sposa e del preventivo. Il cliente può firmarlo elettronicamente con OTP via email.",
    tip: "La firma elettronica ha validità legale e il PDF firmato include l'audit trail completo.",
  },
  tab_timeline: {
    title: "Timeline operativa",
    text: "La sequenza esatta del giorno del matrimonio: orari, durate, blocchi (trucco sposa, capelli, mamma, damigelle). Si calcola in automatico dall'orario di inizio.",
    tip: "Condividi la timeline con team e sposa per evitare imprevisti il giorno dell'evento.",
  },
  tab_map: {
    title: "Mappa",
    text: "Visualizza location della cerimonia, della preparazione e dei fornitori sulla stessa mappa. Utile per pianificare gli spostamenti.",
  },
  tab_wedding_day: {
    title: "Wedding Day",
    text: "Tutto quello che ti serve il giorno dell'evento: orario di partenza intelligente, meteo previsto e suggerimenti AI per hair e makeup in base alle condizioni reali.",
    tip: "Apri questa scheda la mattina del matrimonio per partire con il piede giusto.",
  },

  // ─── Dashboard ──────────────────────────────────────────────────────────
  dash_leads_banner: {
    title: "Nuove richieste preventivo",
    text: "I lead arrivati dal Lead Machine che non hai ancora aperto. Sparisce quando apri la scheda o quando invii/firmi il contratto.",
    tip: "Apri ogni nuova richiesta entro 24 ore: i tempi di risposta rapidi convertono il triplo.",
  },
  dash_kpi: {
    title: "Indicatori chiave",
    text: "Le metriche più importanti del tuo studio: clienti attivi, eventi del mese, fatturato, conversioni. Si aggiornano in tempo reale.",
  },
  dash_calendar: {
    title: "Calendario eventi",
    text: "Tutti i tuoi matrimoni e prove in un solo calendario. Filtra per tipologia, operatore o stato. La vista lista mostra anche l'anno.",
    tip: "Clicca un giorno nel calendario per vedere i dettagli degli eventi.",
  },

  // ─── Settings ───────────────────────────────────────────────────────────
  settings_branding: {
    title: "Branding",
    text: "Personalizza nome studio, ruolo, logo e indirizzo di partenza. Questi dati appaiono su preventivi, contratti, email ed pagine pubbliche.",
    tip: "Un logo professionale aumenta la percezione di qualità del tuo studio.",
  },
  settings_lead_link: {
    title: "Lead Machine",
    text: "Il tuo link pubblico personalizzato per ricevere richieste preventivo. Condividilo via WhatsApp, Instagram bio, sito web.",
    tip: "Funziona 24/7: il cliente compila, tu ricevi notifica e apri la scheda con un click.",
  },
  settings_backup: {
    title: "Backup e Ripristino",
    text: "Scarica un archivio ZIP completo con clienti, preventivi, contratti, timeline e foto. Puoi ripristinarlo in qualsiasi momento.",
    tip: "Esegui un backup mensile: i dati restano sul tuo computer, in totale autonomia.",
  },
  settings_security: {
    title: "Sicurezza",
    text: "Gestisci password, sessione attiva e dispositivi collegati. Cambia password regolarmente per proteggere i dati dei tuoi clienti.",
  },
  settings_privacy: {
    title: "Privacy e dati",
    text: "Esporta o cancella tutti i tuoi dati come previsto dal GDPR. La cancellazione è definitiva e irreversibile.",
    tip: "Prima di cancellare, scarica un backup completo.",
  },
};

export default TIPS;
